import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeShare} from "./doppe-action-type-share";

export const doppeActionTypeShareViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeShare, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeShareWidget: (await import('./doppe-action-type-share-widget/doppe-action-type-share-widget')).DoppeActionTypeShareWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeShareWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeShareWidget
                {...renderProps}
            />
        );

    }
})